import React, {useEffect} from 'react';
import { KoFormBuilder } from 'packages';
import styles from './curd.module.scss';

function GeneralInfoCrud({ form, product }) {


  useEffect(()=>{
    form?.resetFields();
  },[]);

  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues: product,
    colon: true,
    fields: [
      {
        key: 'firstname', label: 'Frist Name' , placeholder: 'Ex: apple', colSpan: 2,
        rules: [
          {
            required: true,
            message: 'Frist name is required'
          }
        ]
      },
      {
        key: 'lastname', label: 'Last Name' , placeholder: 'Ex: apple', colSpan: 2,
        rules: [
          {
            required: true,
            message: 'Last name is required'
          }
        ]
      },
      {
        key: 'companyname', label: 'Company Name' , placeholder: 'Ex: Kwapio PSA', colSpan: 4},
      {
        key: 'vendorname ', label: 'Vendor Display Name ' , placeholder: 'Ex: Kwapio PSA', colSpan: 2,rules: [
          {
            required: true,
            message: 'Vendor name is required'
          }
        ]},
      {
        key: 'phoneno',
        label: 'Vendor Phone',
        colSpan: 2,
        rules: [
          {
            required: true,
            message: 'Phone is required'
          }
        ]
      }
    ]
  };
  return (
    <div className={styles.wrapper}>
      <KoFormBuilder form={form} meta={meta} />
    </div>
  );
};

export default GeneralInfoCrud;